<template>
  <div class="info-wrap">
    <div class="info-title">信息化系统</div>
    <div class="info-sub-title">INFORMATION SYSTEM</div>
    <div class="info-content">
      <div
        v-for="item in list"
        :key="item.key"
        class="item-info-box"
        @click="handleTo(item.key)"
      >
        <div
          class="img-box"
          @mouseenter="handleMouseEnter(item.key)"
          @mouseleave="handleMouseLeave"
        >
          <div v-if="select === item.key" class="img-shadow"></div>
          <img :src="item.img" alt="img" class="card-img" />
        </div>
        <div class="brief-title">{{ item.title }}</div>
        <div class="brief-content">
          {{ item.content }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import img1 from "../../assets/sys/sys1.png";
import img2 from "../../assets/sys/sys2.png";
import img3 from "../../assets/sys/sys3.png";
export default {
  name: "infoBox",
  data() {
    return {
      list: [
        {
          key: "1",
          img: img1,
          title: "一站式一体化体检信息化系统",
          content:
            "为不同规模的健康体检中心提供全流程的信息化解决方案，包括检前预约、检中一体化体检信息管理系统、全流程智能导检系统、检后随访及报告解读、视频问诊系统、职业病体检系统、移动外检体检系统 、CDM系统...",
        },
        {
          key: "2",
          img: img2,
          title: "十九年运营管理经验",
          content:
            "凭借十九年健康体检中心运营经验，通过将服务组件模块化，增强机构对人、财、物等综合资源的协调统一，保证医疗质量的同时，实现健康体检中心口碑的有效提升。",
        },
        {
          key: "3",
          img: img3,
          title: "十六年体检信息化研发迭代经验积累",
          content:
            "用户需求调研，系统开发、系统上线、后续支持，全过程实现可视化、规范化管理，根据客户反馈，支持持续迭代更新系统，提供更智能、高效和个性化的售后支持和服务，提升运维服务效率、内部管理效率和客户满意度。",
        },
      ],
      select: null,
    };
  },
  methods: {
    handleTo(type) {
      this.$router.push({ path: "/product", query: { type: type } });
    },
    handleMouseEnter(type) {
      this.select = type;
    },
    handleMouseLeave() {
      this.select = null;
    },
  },
};
</script>
<style scoped lang="less">
.info-wrap {
  width: 1200px;
  margin: 0 auto;
  background: #fff;
  .info-title {
    color: #296db2;
    font-size: 40px;
    font-weight: bold;
    text-align: center;
    margin-top: 98px;
  }
  .info-sub-title {
    font-size: 16px;
    font-weight: 400;
    color: #999999;
    text-align: center;
    margin-top: 14px;
  }
  .info-content {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .item-info-box {
      width: 395px;
      height: 508px;
      background: #f6f8fa;
      box-sizing: border-box;
      padding: 7px;
      //
      .img-box {
        width: 100%;
        height: 270px;
        position: relative;
        .img-shadow {
          position: absolute;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.4);
        }
        .card-img {
          width: 100%;
          height: 100%;
        }
      }
      //
      .brief-title {
        font-size: 22px;
        color: #333333;
        margin-top: 12px;
        box-sizing: border-box;
        padding: 0 10px;
      }
      .brief-content {
        color: #999999;
        margin-top: 16px;
        font-size: 16px;
        box-sizing: border-box;
        padding: 0 10px;
      }
    }
  }
}
</style>
